import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Notificacion} from 'src/app/models/notificacion';
import { Reduccion } from 'src/app/models/reduccion';
import {Solicitud} from 'src/app/models/solicitud';
import {PageFilterQueryModel, PagesResponseFilterQuery} from "../../models/filter-query-model";
import {userResponse} from "../../models/estados";
import {
  ValidationModel,
  ValidationRequestChangeStatus,
  ValidationResponseChangeStatus
} from "../../models/validation-request";

@Injectable()
export class NegosService {

  readonly solicitudApi = '/api/create/';

  constructor(private http: HttpClient) {
  }

  validate(solicitudes: Solicitud[]): Observable<Notificacion[]> {
    const url = this.solicitudApi +  'solicitud/validate';
    return this.http.post<Notificacion[]>(url, solicitudes).pipe(
      catchError(e => {
        console.error(e.error.message);
        return throwError(() => new Error(e.error.message));
      })
    );
  }

  create(solicitudes: Solicitud[]): Observable<Solicitud[]> {
    const url = this.solicitudApi +  'solicitud/';
    return this.http.post<Solicitud[]>(url, solicitudes).pipe(
      catchError(e => {
        console.error(e.error.message);
        return throwError(() => new Error(e.error.message));
      })
    );
  }

  validateReduction(reducciones: Reduccion[]): Observable<Notificacion[]> {
    const url = this.solicitudApi +  'reduccion/validate';
    return this.http.post<Notificacion[]>(url, reducciones).pipe(
      catchError(e => {
        console.error(e.error.message);
        return throwError(() => new Error(e.error.message));
      })
    );
  }

  createReduction(reducciones: Reduccion[]): Observable<Reduccion[]> {
    const url = this.solicitudApi +  'reduccion/send';
    return this.http.post<Reduccion[]>(url, reducciones).pipe(
      catchError(e => {
        console.error(e.error.message);
        return throwError(() => new Error(e.error.message));
      })
    );
  }

  postSearhData(solicitudes: PageFilterQueryModel): Observable<PagesResponseFilterQuery> {
    const url = this.solicitudApi + 'solicitud/negos/';
    return this.http.post<PagesResponseFilterQuery>(url, solicitudes).pipe(
      catchError(e => {
        console.error(e.error.message);
        return throwError(() => new Error(e.error.message));
      })
    );
  }

  getAllNegosWithoutPNR(solicitudes: PageFilterQueryModel): Observable<PagesResponseFilterQuery>{
    const url = this.solicitudApi + 'solicitud/negos/pnr';
    return this.http.post<PagesResponseFilterQuery>(url, solicitudes).pipe(
      catchError(e => {
        console.error(e.error.message);
        return throwError(() => new Error(e.error.message));
      })
    );
  }

  getUserEstados(): Observable<userResponse[]> {
    const url = this.solicitudApi + 'solicitud/negos/solicitantes';
    return this.http.get<userResponse[]>(url).pipe(
      catchError(e => {
        console.error(e.error.message);
        return throwError(() => new Error(e.error.message));
      })
    );
  }

  /**
   * Inicia el proceso de Evaluacion de una nego
   * @param validationRequestChangeStatus
   */
  changeStatusNego(validationRequestChangeStatus: ValidationRequestChangeStatus){
    const url = this.solicitudApi + 'proceso/';
    return this.http.post<ValidationResponseChangeStatus>(url, validationRequestChangeStatus).pipe(
      catchError(e => {
        return throwError(() => new Error(e.error.message));
      })
    );
  }

  /**
   * Inicia el proceso de envio a Sabre de una nego
   * @param validationRequestChangeStatus
   */
  createNego(validationRequestChangeStatus: ValidationRequestChangeStatus){
    const url = this.solicitudApi + 'proceso/send';
    return this.http.post<ValidationResponseChangeStatus>(url, validationRequestChangeStatus).pipe(
      catchError(e => {
        return throwError(() => new Error(e.error.message));
      })
    );
  }

  rejectionNego(validationChangeStatus: ValidationModel){
    const url = this.solicitudApi + 'solicitud/rejection/';
    return this.http.post<ValidationResponseChangeStatus>(url, validationChangeStatus).pipe(
      catchError(e => {
        return throwError(() => new Error(e.error.message));
      })
    );
  }

  //TODO no tiene tests
  approvalNego(validationChangeStatus: ValidationModel){
    const url = this.solicitudApi + 'solicitud/approval';
    return this.http.post<ValidationResponseChangeStatus>(url, validationChangeStatus).pipe(
      catchError(e => {
        return throwError(() => new Error(e.error.message));
      })
    );
  }


}
